/**
 * Подтверждение заявки на обновление номера телефона
 */
export const confirmClaim = (data) => ({
    url: '/claim/confirm',
    method: 'PUT',
    data,
});
